import React, { FC } from 'react';
import styles from './Loader.module.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface LoaderProps {}

const Loader: FC<LoaderProps> = () => (

  <div className={styles.Loader}>
    <div id="global-loader">
        {/* <img src={require("../../assets/images/loader.svg").default} className="loader-img" alt="Loading...."/> */}

        
<div className="dimmer active loader-img">
                          <div className="spinner1">
                              <div className="double-bounce1"></div>
                              <div className="double-bounce2"></div>
                          </div>
                      </div>
    </div>

  </div>
);

export default Loader;
